import React from 'react';
import { SelectedIcon } from './SelectedIcon';
export const SelectableWrapper = ({ onSelect, isDisabled, children, isSelected, selectedStyle, dataHook, selectedIcon = React.createElement(SelectedIcon, null), }) => {
    const handleSelect = () => {
        if (!isDisabled) {
            onSelect();
        }
    };
    const child = React.Children.toArray(children).find((c) => React.isValidElement(c));
    const borderRadius = child.props.borderRadius;
    const wrapperBorderWidth = selectedStyle?.border?.match(/\b(\d+)px\b/)?.[0];
    const overrideProps = isSelected ? { borderColor: 'transparent' } : {};
    const modifiedChild = React.cloneElement(child, overrideProps);
    const style = isSelected
        ? selectedStyle
        : {
            borderColor: 'transparent',
            borderWidth: wrapperBorderWidth,
            borderStyle: 'solid',
        };
    return (React.createElement("div", { "data-hook": dataHook, onClick: handleSelect, style: {
            ...style,
            position: 'relative',
            cursor: 'pointer',
            borderRadius,
            boxSizing: 'border-box',
        } },
        isSelected && selectedIcon,
        modifiedChild));
};
//# sourceMappingURL=SelectableWrapper.js.map